import { createI18n, type Composer } from 'vue-i18n';

import en from './locales/en.json';
import es from './locales/es.json';

const messages = {
  en,
  es,
};

export default createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    // declares $t()
    $t: Composer['t'];
  }
}
